import { CONFIG } from '../config'
import { IFavouriteTagInput, IShopifyAddTagsResponse, IShopifyRemoveTagsResponse, IShopifyGetFavouriteOrderResponse } from '../interfaces'
import { HTTPService } from './http.service'
import { IShopifyNodesRestfulApi } from '../interfaces/shopify/checkout.interfaces';

class YFSubscriptionPrivateService extends HTTPService {
  private endpoint: string = `${CONFIG.shopify.yfSubscriptionPrivateEndpoint}/v1/orders/favouriteOrder`

  async removeFavouriteTag({ orderId, customerId }: IFavouriteTagInput): Promise<IShopifyRemoveTagsResponse | null> {
    try {
      return await this.delete(this.endpoint, {
        orderId,
        customerId
      })
    } catch (e) {
      console.error('Request Error:', e)
      return null
    }
  }

  async addFavouriteTag({ orderId, customerId }: IFavouriteTagInput): Promise<IShopifyAddTagsResponse | null> {
    try {
      return await this.put(this.endpoint, {
        orderId,
        customerId
      })
    } catch (e) {
      console.error('Request Error:', e)
      return null
    }
  }

  async getFavouriteOrder({ customerId }: IFavouriteTagInput): Promise<IShopifyGetFavouriteOrderResponse | null> {
    try {
      return await this.get(`${this.endpoint}?customerId=${customerId}`)
    } catch (e) {
      console.error('Request Error:', e)
      return null
    }
  }

  /**
   * This function calls the backend API to get order details. It is authenticated with a Shopify CAT.
   * @param id: order ID
   * @param customerId: customer ID
   * @returns a promise of the get request
   */
  async getOrderByIdRestfulApi(id: string, customerId: string): Promise<IShopifyNodesRestfulApi> {
    try {
      const customerAccessToken = sessionStorage.getItem('shop_session');
      if (!customerAccessToken) {
        throw new Error("Can't find Customer Access Token")
      }
      return this.get(`${CONFIG.shopify.yfSubscriptionPrivateEndpoint}/v1/orders?orderId=${id}&customerId=${customerId}&customerAccessToken=${customerAccessToken}`)
    } catch (e) {
      console.error('Request Error:', e)
      return null
    }
  }
}

export const yfSubscriptionPrivateService = new YFSubscriptionPrivateService()
